import Field from "./Field"
import Label from "./FieldLabel"
import Messages from "./FieldMessages"
import Text from "./FieldText"

export default Object.assign(Field, {
  Label,
  Messages,
  Text
})
